import { MainButton } from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import { useShallow } from 'zustand/react/shallow'
import i18n from '../../../i18n/i18next'
import { useBoundStore } from '../../../state/bound.store'
import { isConnectivityAvailable } from '../../connectivity/connectivityListener'
import { NavigationView } from '../../layout/NavigationView'
import { AccountAvatarStack } from '../accountPage/accountAvatarStack'
import { ProfileDetails } from './profileDetails'

export const ProfilePage = () => {
    const { profileRequired, wpUser } = useBoundStore(
        useShallow((s) => {
            return {
                profileRequired: s.profileRequired,
                wpUser: s.wpUser,
            }
        })
    )

    return (
        <NavigationView
            profilePage
            navigationBarTitle={i18n.t('account.profile.title')}
            backButtonAction={() => {
                window.goBack()
            }}
            navigationBarTrailing={[
                {
                    id: 'editButton',
                    icon: 'Edit',
                    disabled: !isConnectivityAvailable.value,
                    action: () => {
                        window.pushPath('/account/profile/edit')
                    },
                },
            ]}
            count={profileRequired?.length ?? 0}
            usePageTransition
        >
            <Stack
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <Stack style={{ position: 'relative' }}>
                    <div
                        style={{
                            position: 'absolute',
                            height: '110px',
                            width: '100%',
                        }}
                    />
                    <AccountAvatarStack profilePage={true} />

                    <Stack
                        style={{
                            padding: '0px 24px',
                        }}
                    >
                        {<ProfileDetails user={wpUser} profilePage />}
                    </Stack>
                    <Stack
                        spacing="16px"
                        justifyContent="center"
                        alignItems="center"
                        padding="16px"
                    >
                        <MainButton
                            id="contactSupportButton"
                            variant="borderless"
                            onClick={() => {
                                window.location.href =
                                    'mailto:eventr-admin@softpauer.com'
                            }}
                        >
                            {i18n.t('delete-account.contact-support')}
                        </MainButton>
                        <MainButton
                            id="deleteAccountButton"
                            variant="destructiveBorderless"
                            onClick={() => {
                                window.pushPath('/account/profile/delete')
                            }}
                        >
                            {i18n.t('delete-account.delete')}
                        </MainButton>
                    </Stack>
                </Stack>
            </Stack>
        </NavigationView>
    )
}
